module.exports = __webpack_public_path__ + "static/media/Fiorentina.6bf2d329.png";